import React, { useEffect, useContext } from "react";
import { AuthContext, AppContext } from "@CONTEXTS";
import { Form, Row, Col, Button, Modal, Spin, message } from "antd";
import { HJCreateProduct } from "@FORMS";
import { updateProduct } from "@PRODUCTS";
import { syncUpdatedProductInDeliveryForm } from "@HELPERS";
import { AiFillSave } from "react-icons/ai";

const UpdateProductModal = ({
  form,
  onClose,
  setStep,
  setSpin,
  spin,
  updateValues,
  deliveryForm,
  fieldName,
  isReturned,
  setDeliveryType,
  setDesi,
}) => {
  const { info } = useContext(AuthContext);
  const { options } = useContext(AppContext);
  useEffect(() => {
    let obj;
    if (info?.desiCalculationMode === "DESI_ONLY") {
      obj = {
        code: updateValues.code,
        name: updateValues.name,
        weight: updateValues.weight,
        desi: updateValues.desi,
      };
    } else {
      obj = {
        code: updateValues.code,
        name: updateValues.name,
        width: updateValues.width,
        length: updateValues.length,
        height: updateValues.height,
        weight: updateValues.weight,
      };
    }

    form.setFieldsValue(obj);
  }, [form, updateValues]);

  const handleUpdate = async (values) => {
    setSpin(true);
    let obj;
    if (info?.desiCalculationMode === "DESI_ONLY") {
      obj = {
        code: values.code,
        name: values.name,
        weight: values.weight,
        desi: values.desi,
      };
    } else {
      obj = {
        code: values.code,
        name: values.name,
        width: values.width,
        length: values.length,
        height: values.height,
        weight: values.weight,
      };
    }

    const response = await updateProduct(obj, updateValues._id);

    setSpin(false);

    if (response.id || response._id) {
      syncUpdatedProductInDeliveryForm({
        form: deliveryForm,
        fieldName,
        productId: updateValues._id || updateValues.id,
        updatedProduct: obj,
        desiOptions: isReturned
          ? options["DESI_RETURNED_TMH"]
          : options["DESI_TMH"],
        setDeliveryType,
        setDesi,
      });

      message.success({
        content: "Ürün başarıyla güncellendi",
        className: "app-success-message",
      });
      form.resetFields();
      setStep("TABLE");
    }
  };

  return (
    <Modal
      visible
      title="Malzeme/Ürün Düzenle"
      onCancel={() => {
        setStep("TABLE");
        form.resetFields();
      }}
      width={1350}
      footer={false}
    >
      <Form form={form} layout="vertical">
        <HJCreateProduct form={form} />

        <Row gutter={24}>
          <Col flex={"auto"}>
            <Spin spinning={spin} />
          </Col>
          <Col flex="auto">
            <Button
              style={{ float: "right" }}
              type="danger"
              onClick={() => {
                setStep("TABLE");
                form.resetFields();
              }}
              icon={<AiFillSave />}
            >
              Vazgeç
            </Button>
          </Col>
          <Col flex="none">
            <Button
              style={{ float: "right" }}
              type="primary"
              onClick={() => {
                form.validateFields().then((values) => {
                  handleUpdate(values);
                });
              }}
              icon={<AiFillSave />}
            >
              Malzeme / Ürün Kaydet
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default UpdateProductModal;
